<div class="session">
  <div class="session-content text-xs-center">
    <div>
      <div class="error-title">404</div>
      <div class="error-subtitle">Sayfa bulunamadi!</div>
      <p class="mat-text-muted">Bu saayfa bulunamadi. <a href="javascript:;">Bu hatayi raporla?</a></p>
    </div>
  </div>
</div>
